// extracted by mini-css-extract-plugin
module.exports = {"btn":"AddButton_btn__1MCVC","disabled":"AddButton_disabled__1wYDX","wide":"AddButton_wide__1cuLl","solid":"AddButton_solid__2fj-U","small":"AddButton_small__3ZXzG"};